import { useState } from "react";
import { Reveal } from "./Reveal";

const logoUrl = (domain) =>
  `https://www.google.com/s2/favicons?domain=${domain}&sz=128`;

const CLIENTS = [
  { name: "Zydus", domain: "zyduslife.com" },
  { name: "Amaron", domain: "amaron.com" },
  { name: "Shriram Properties", domain: "shriramproperties.com" },
  { name: "TVS Motors", domain: "tvsmotor.com" },
  { name: "Sundaram Business", monogram: "SB" },
  { name: "Casagrand", domain: "casagrand.co.in" },
  { name: "JBS Football Academy", monogram: "JBS" },
  { name: "TEDx", monogram: "TEDx" },
  { name: "Amazon", domain: "amazon.com" },
  { name: "Deutsche Bank", domain: "db.com" },
  { name: "Cisco", domain: "cisco.com" },
  { name: "Siemens Energy", domain: "siemens-energy.com" },
];

const ClientChip = ({ client, index }) => {
  const [imgFailed, setImgFailed] = useState(false);
  const showImg = client.domain && !imgFailed;

  return (
    <div
      data-testid={`client-chip-${index}`}
      className="group flex items-center gap-4 px-8 py-5 border border-[rgba(212,175,55,0.2)] bg-[#0d0d10] hover:border-[rgba(212,175,55,0.55)] hover:bg-[#121215] transition-all duration-500 shrink-0"
    >
      {showImg ? (
        <img
          src={logoUrl(client.domain)}
          alt={`${client.name} logo`}
          loading="lazy"
          onError={() => setImgFailed(true)}
          className="w-9 h-9 object-contain grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500"
        />
      ) : (
        <span className="w-9 h-9 flex items-center justify-center border border-[rgba(212,175,55,0.45)] font-cinzel text-[10px] font-bold gold-text">
          {client.monogram || client.name.slice(0, 2).toUpperCase()}
        </span>
      )}
      <span className="font-cinzel text-sm tracking-[0.2em] uppercase text-zinc-400 group-hover:text-[#f3e5ab] transition-colors duration-500 whitespace-nowrap">
        {client.name}
      </span>
    </div>
  );
};

export default function Clients() {
  const doubled = [...CLIENTS, ...CLIENTS];
  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="relative py-24 sm:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="text-center">
          <span
            data-testid="clients-eyebrow"
            className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#d4af37] font-semibold mb-4 block"
          >
            Trusted By
          </span>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
            In <span className="gold-text">good company</span>
          </h2>
          <p className="mt-5 text-sm sm:text-base text-zinc-500 max-w-xl mx-auto leading-relaxed">
            Stage-shakers, fortune builders and global giants — a few names
            we've had the honour of crafting golden moments for.
          </p>
        </Reveal>
      </div>

      <div
        data-testid="clients-marquee"
        className="mt-14 relative overflow-hidden [mask-image:linear-gradient(90deg,transparent,black_12%,black_88%,transparent)]"
      >
        <div
          className="animate-marquee flex w-max gap-5 pr-5"
          style={{ animationDuration: "60s" }}
        >
          {doubled.map((c, i) => (
            <ClientChip key={`${c.name}-${i}`} client={c} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
